import { map } from 'lodash';
import type { IObjectivePossibleBeneficialChangesToFinancialSituation } from './ObjectivePossibleBeneficialChangesToFinancialSituation.interface';
import ObjectiveApplicant from './ObjectiveApplicant';
import ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange from './ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange';
import { YesNoOption } from '../global/YesNoOption.enum';

export default class ObjectivePossibleBeneficialChangesToFinancialSituation
  implements IObjectivePossibleBeneficialChangesToFinancialSituation {
  planChangesToTheirFinancialCircumstances: YesNoOption;
  applicants: Array<ObjectiveApplicant>;
  natureOfPlannedChange: ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange;

  static build = (data: IObjectivePossibleBeneficialChangesToFinancialSituation) =>
    new ObjectivePossibleBeneficialChangesToFinancialSituation(data);

  static blank = () => new ObjectivePossibleBeneficialChangesToFinancialSituation();

  /**
   * Constructor
   * @param {IObjectivePossibleBeneficialChangesToFinancialSituation} data
   */
  constructor(data?: IObjectivePossibleBeneficialChangesToFinancialSituation) {
    this.planChangesToTheirFinancialCircumstances = YesNoOption.of(
      data?.planChangesToTheirFinancialCircumstances?.name ||
        data?.planChangesToTheirFinancialCircumstances?.toString()
    );
    this.applicants = map(data?.applicants, (obj) => new ObjectiveApplicant(obj));
    this.natureOfPlannedChange = new ObjectivePossibleBeneficialChangesToFinancialSituationNatureOfPlannedChange(
      data?.natureOfPlannedChange
    );
  }
}
